/**
 * F101 пака `tails-closeout` (С-I, NC-45, SOLUTION § 10.6 п. 5; К5-12…К5-14) — знак минус U+2212 в
 * ПОКАЗЕ чисел.
 *
 * `Intl.NumberFormat` (ru, en, kk) ставит перед отрицательным дефис-минус U+002D: он короче цифры и
 * в моно-колонке сбивает выравнивание знака. Показ — U+2212 одним помощником во всех трёх семействах
 * форматтеров (`@staiter/i18n/format`, `lib/format/money.ts`, `lib/format/index.ts`) и в ручных
 * знаках — в одной таблице один знак.
 *
 * ГРАНИЦА. Только показ. Поля ввода держат в `value` ASCII (`Number('−5')` = NaN, правка теряется) —
 * `asciiSign`; разбор принимает оба знака — `normaliseSign`; копирование в буфер меняет U+2212 на `-`
 * глобальным обработчиком `copy` (иначе Excel читает сумму как текст). Экспорт не затронут: бэкенд
 * эти форматтеры не импортирует (К5-22).
 */
/** Знак минус U+2212 — тот, что показывает интерфейс. */
export const MINUS_SIGN = '−';
/**
 * Дефис-минус перед числом (в начале строки, после пробела или скобки; перед цифрой, символом валюты
 * или разделителем) → U+2212. Дефисы внутри слов и диапазонов «1-2» не трогаются.
 */
const LEADING_HYPHEN_RE = /(^|[\s(])-(?=[\d\p{Sc}.,])/gu;
export function displaySign(text) {
    return text.replace(LEADING_HYPHEN_RE, `$1${MINUS_SIGN}`);
}
/** Для `value` полей ввода: показанный U+2212 (и похожие тире) → ASCII `-`. */
const MINUS_LIKE_RE = /[−‒–﹣－]/g;
export function asciiSign(text) {
    return text.replace(MINUS_LIKE_RE, '-');
}
/** Разбор ввода принимает оба знака — синоним `asciiSign` для читаемости в разборщиках. */
export const normaliseSign = asciiSign;
//# sourceMappingURL=sign.js.map